import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import {
  KyrgyzstanFiltersState,
  type PriceRangeValue,
} from 'entities/kyrgyzstan/model'

import { FilterSection } from 'shared/ui/filter-section'

import { PriceRange } from './ui/price-range'
import { RealtyTypeOptions } from './ui/realty-type-options'

import s from './styles.module.scss'

interface KyrgyzstanFiltersWidgetProps {
  className?: string
  filters: KyrgyzstanFiltersState
  minPrice: number
  maxPrice: number
  onFiltersChange: (updates: Partial<KyrgyzstanFiltersState>) => void
}

export const KyrgyzstanFiltersWidget = ({
  className,
  filters,
  minPrice,
  maxPrice,
  onFiltersChange,
}: KyrgyzstanFiltersWidgetProps) => {
  const { t } = useTranslation()

  const handleRealtyTypeChange = (typeIds?: number[]) => {
    onFiltersChange({ realtyTypeIds: typeIds })
  }

  const handlePriceRangeChange = (priceRange: PriceRangeValue) => {
    onFiltersChange({ priceRange })
  }

  return (
    <div className={clsx(s.container, className)}>
      <FilterSection title={t('kyrgyzstan_block.filters.price.title')}>
        <PriceRange
          defaultValue={filters.priceRange}
          min={minPrice}
          max={maxPrice}
          onChange={handlePriceRangeChange}
        />
      </FilterSection>

      <FilterSection title={t('kyrgyzstan_block.filters.type.title')}>
        <RealtyTypeOptions
          selectedTypeIds={filters.realtyTypeIds}
          onTypeChange={handleRealtyTypeChange}
        />
      </FilterSection>

      {/* <FilterSection title={t('kyrgyzstan_block.filters.stars.title')}>
        <StarOptions options={starOptions} />
      </FilterSection> */}
    </div>
  )
}
